import { useLazyQuery as u } from "@apollo/client";
import c from "../graphql/query/verifyContractTransaction.js";
import { ERROR_CODE as m } from "../../temp-lib/constants/error.js";
import { RETRY as f } from "../../temp-lib/constants/retry.js";
import { CustomError as p } from "../../temp-lib/errors/customError.js";
import y from "p-retry";
import * as R from "ramda";
import { useCallback as a } from "react";
const S = () => {
  const [t] = u(c), e = a(
    async (r) => {
      const { uniqueIDType: o = "", uniqueID: s = "", eventName: n } = r, i = await t({
        variables: {
          input: {
            uniqueIDType: o,
            uniqueID: s,
            eventName: n
          }
        }
      });
      if (!R.pathOr(!1, ["data", "getTxnStatus"], i))
        throw new p(
          "wait for operation result",
          m.CONTRACT.WAIT_SEND_OPERATION_RESULT
        );
      return !0;
    },
    [t]
  );
  return { verify: a(
    async (r) => {
      try {
        return await y(async () => {
          await e(r);
        }, f.GRAPHQL.POLL_AFTER_TX_SUCCESS.DEFAULT), !0;
      } catch {
        return !1;
      }
    },
    [e]
  ) };
};
export {
  S as default
};
//# sourceMappingURL=useVerifyContractTransaction.js.map
